module.exports = __webpack_public_path__ + "img/connector-line.7b4994aa.svg";